module.exports = __webpack_public_path__ + "img/Besties.5e30578f.jpg";